// VORSØ native cart drawer (replaces Kaching Cart).
const root = document.getElementById('vs-cart');

if (root && !window.vsCart) {
  let config;
  let cart;
  let lastFocus = null;
  let lastPct = 0; // free-shipping bar animates from here (0 on every open, like Kaching)
  const collapsed = new Set();
  const $ = (sel) => root.querySelector(sel);
  const contents = $('[data-vs-contents]');
  const footerWrap = $('[data-vs-footer-wrap]');
  const footer = $('[data-vs-footer]');
  const empty = $('[data-vs-empty]');

  const getConfig = () => {
    if (!config) {
      try {
        config = JSON.parse(document.getElementById('vs-cart-config').textContent);
      } catch (e) {
        config = { threshold: 0, upsells: [], cart: null };
      }
    }
    return config;
  };

  const rate = () => parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
  const money = (cents) => {
    const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || (cart && cart.currency) || 'USD';
    const whole = Math.round(cents) % 100 === 0;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: cur,
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: whole ? 0 : 2,
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(whole ? 0 : 2);
    }
  };
  const esc = (s) =>
    String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const img = (url, w) => (url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '');

  const ICON_TAG =
    '<svg viewBox="0 0 12 12" aria-hidden="true"><path fill="currentColor" fill-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z"/></svg>';
  const ICON_TAG_OUTLINE =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M8 8h.01M4.6 2.9 2.9 4.6c-.3.3-.5.5-.6.7-.1.2-.2.4-.2.6-.1.2-.1.5-.1 1v2.8c0 .5 0 .7.1 1 0 .2.1.4.2.6.1.2.3.4.6.7l7.7 7.7c1.2 1.2 1.8 1.8 2.5 2 .6.2 1.2.2 1.9 0 .7-.2 1.3-.8 2.5-2l2.2-2.2c1.2-1.2 1.8-1.8 2-2.5.2-.6.2-1.2 0-1.9-.2-.7-.8-1.3-2-2.5L12 2.9c-.3-.3-.5-.5-.7-.6-.2-.1-.4-.2-.6-.2-.2-.1-.5-.1-1-.1H6.8c-.5 0-.7 0-1 .1-.2 0-.4.1-.6.2-.2.1-.4.3-.6.6z" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const ICON_TRASH =
    '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M10.7 4v-.5c0-.8 0-1.1-.2-1.4a1.3 1.3 0 0 0-.6-.6c-.3-.2-.6-.2-1.4-.2H7.5c-.8 0-1.1 0-1.4.2-.3.1-.5.3-.6.6-.2.3-.2.6-.2 1.4V4M2 4h12m-1.3 0v7.5c0 1.1 0 1.7-.2 2.1-.2.4-.5.7-.9.9-.4.2-1 .2-2.1.2H6.5c-1.1 0-1.7 0-2.1-.2-.4-.2-.7-.5-.9-.9-.2-.4-.2-1-.2-2.1V4" stroke="currentColor" stroke-opacity=".8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const ICON_CHEVRON =
    '<svg viewBox="0 0 20 20" aria-hidden="true"><path fill-rule="evenodd" d="M14.5 12.3a.8.8 0 0 1-1 0L10 8.8l-3.5 3.5a.8.8 0 0 1-1-1l4-4a.8.8 0 0 1 1 0l4 4a.8.8 0 0 1 0 1Z"/></svg>';
  const ICON_DOT = (active) =>
    `<svg class="vs-tier__dot" viewBox="0 0 22 22" fill="none" aria-hidden="true"><circle cx="11" cy="11" r="10" fill="currentColor" stroke="currentColor" stroke-width="2"/><circle cx="11" cy="11" r="6" fill="currentColor" stroke="white" stroke-width="2"/></svg>`;
  const ICON_TRUCK =
    '<svg viewBox="0 0 16 14" fill="none" aria-hidden="true"><path d="M10.3 9.7V3.1c0-.7 0-1.1-.1-1.4a1.3 1.3 0 0 0-.6-.6C9.3 1 8.9 1 8.2 1H3.1c-.7 0-1.1 0-1.4.1a1.3 1.3 0 0 0-.6.6C1 2 1 2.4 1 3.1v4.4c0 .7 0 1.1.1 1.4.1.3.4.5.6.6.3.2.7.2 1.4.2h7.2Zm0 0h2.9c.4 0 .6 0 .7-.1a.7.7 0 0 0 .3-.3c.1-.1.1-.3.1-.7V6.8c0-.2 0-.2 0-.3a.7.7 0 0 0-.1-.2l-.2-.2-1.4-1.4-.2-.2a.7.7 0 0 0-.2-.1H10.3M5.7 11.3a1.7 1.7 0 1 1-3.3 0 1.7 1.7 0 0 1 3.3 0Zm7.3 0a1.7 1.7 0 1 1-3.3 0 1.7 1.7 0 0 1 3.3 0Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const ICON_PREV = '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M12.5 15 7.5 10l5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const ICON_NEXT = '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="m7.5 15 5-5-5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  // ---------- rendering ----------
  const isPack = (item) => item.properties && item.properties._bundle_type === 'pack' && item.quantity > 1;
  const realOptions = (item) =>
    (item.options_with_values || []).filter((o) => !(o.name === 'Title' && o.value === 'Default Title'));

  function tierHTML() {
    const c = getConfig();
    if (!c.threshold) return '';
    const goal = Math.round(c.threshold * rate());
    const total = cart.total_price;
    const pct = Math.max(0, Math.min(100, (total / goal) * 100));
    const done = total >= goal;
    const title = esc(c.tierTitle || 'Free Shipping');
    const text = done
      ? `<span><strong>${title}</strong> unlocked</span>`
      : `<span>Add <strong>${money(goal - total)}</strong> to unlock <strong>${title}</strong></span>`;
    return `<div class="vs-tier">
      <p class="vs-tier__text">${text}</p>
      <div class="vs-tier__track">
        <div class="vs-tier__icon${done ? ' is-active' : ''}">${ICON_DOT()}<div class="vs-tier__tip">${ICON_TRUCK}<span>${title}</span></div></div>
        <div class="vs-tier__fill" style="transform:scaleX(${lastPct})" data-to="${pct / 100}"></div>
      </div>
    </div>`;
  }

  function itemHTML(item) {
    const saved = item.original_line_price - item.final_line_price;
    const pack = isPack(item);
    const opts = realOptions(item);
    const title = esc(item.product_title);
    const url = esc(item.url);
    let left = '';
    if (pack) {
      const open = !collapsed.has(item.key);
      left = `<a class="vs-item__title" href="${url}"><span class="vs-item__bq">${item.quantity}x </span>${title}</a>
        <span class="vs-badge vs-badge--bundle">${ICON_TAG}<span>${esc(item.properties._bundle)}</span></span>
        <button type="button" class="vs-item__toggle" data-vs-toggle="${esc(item.key)}" aria-expanded="${open}">${open ? 'Hide' : 'Show'} ${item.quantity} items${ICON_CHEVRON}</button>
        <div class="vs-item__variants"${open ? '' : ' hidden'}><span>${item.quantity}× ${esc(opts.map((o) => o.value).join(', '))}</span></div>`;
    } else {
      left = `<a class="vs-item__title" href="${url}">${title}</a>`; /* VORSØ: quantity now lives in the stepper below the options */
      if (opts.length) {
        const vsLines = opts.map((o) => { const n = String(o.name); const vv = String(o.value); const k = vv.toUpperCase().indexOf(n.toUpperCase()); const v = (k >= 0 ? vv.slice(0, k) + vv.slice(k + n.length) : vv).trim() || vv; return { n, t: n + ": " + v }; }); vsLines.sort((a, b) => (b.n.toUpperCase() === "SIZE") - (a.n.toUpperCase() === "SIZE")); left += `<div class="vs-item__vars">${vsLines.map((l) => `<span class="vs-item__optvalues">${esc(l.t)}</span>`).join("")}</div>`; /* VORSØ sleek: one option per line, SIZE first, e.g. SIZE: M / INSEAM: 5" */
      }
      left += `<div class="vs-qty" role="group" aria-label="Quantity"><button type="button" class="vs-qty__btn" data-vs-qty="-1" aria-label="Decrease quantity"${item.quantity <= 1 ? ' disabled' : ''}><svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 6h8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button><span class="vs-qty__val" data-vs-qty-val aria-live="polite">${item.quantity}</span><button type="button" class="vs-qty__btn" data-vs-qty="1" aria-label="Increase quantity"><svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 6h8M6 2v8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button></div>`; /* VORSØ: quantity stepper under SIZE (Nov 3) */
    }
    const price = `<div class="vs-item__total"><span class="vs-item__final">${money(item.final_line_price)}</span>${saved > 0 ? `<s class="vs-item__old">${money(item.original_line_price)}</s>` : ''}</div>`; /* VORSØ sleek: price, then struck price */
    const badge = saved > 0 ? `<span class="vs-badge">${ICON_TAG}<span>You save ${money(saved)}</span></span>` : '';
    return `<div class="vs-item" data-key="${esc(item.key)}">
      <a class="vs-item__img" href="${url}" tabindex="-1">${item.image ? `<img src="${esc(img(item.image, 160))}" alt="${title}" decoding="async" width="80" height="100">` : ''}</a>
      <div class="vs-item__content">
        <div class="vs-item__left">${left}</div>
        <div class="vs-item__right">
          <div class="vs-item__price">${price}${badge}</div>
          <button type="button" class="vs-item__remove" data-vs-remove="${esc(item.key)}" aria-label="Remove ${title} from cart">${ICON_TRASH}</button>
        </div>
      </div>
    </div>`;
  }

  function upsellHTML() {
    const inCart = new Set(cart.items.map((i) => i.product_id));
    const list = (getConfig().upsells || []).filter((u) => !inCart.has(u.productId) && u.variants.some((v) => v.available));
    if (!list.length) return '';
    const col = (u) => {
      const v = u.variants.find((x) => x.available) || u.variants[0];
      const price = Math.round(v.price);
      const off = Math.round((u.discount || 0) * rate());
      const final = Math.max(0, price - off);
      const hasOptions = !(u.options.length === 1 && u.variants.length === 1);
      const single = (u.options || []).length === 1;
      const selects = (u.options || [])
        .map(
          (name, oi) =>
            `<fieldset class="vs-up__pills" data-vs-up-option="${oi}" aria-label="${esc(name)}">${[...new Set(u.variants.map((x) => x.options[oi]))]
              .map((val) => {
                const off = single && !u.variants.some((x) => x.options[oi] === val && x.available);
                return `<label class="vs-up__pill"><input type="radio" name="vs-up-${u.productId}-${oi}" value="${esc(val)}"${v.options[oi] === val ? ' checked' : ''}${off ? ' disabled' : ''}><span>${esc(val)}</span></label>`;
              })
              .join('')}</fieldset>`
        )
        .join('');
      return `<div class="vs-up__item" data-vs-up="${u.productId}">
        <a class="vs-up__img" href="${esc(u.url)}">${u.image ? `<img src="${esc(u.image)}" alt="${esc(u.title)}" decoding="async" width="112" height="140">` : ''}</a>
        <div class="vs-up__content">
          <a class="vs-up__title" href="${esc(u.url)}">${esc(u.title)}</a>${u.lab ? `<button type="button" class="vs-up__lab" data-vs-lab="${u.productId}" data-vs-lab-url="${esc(u.labUrl)}" aria-haspopup="dialog"><svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="10" fill="currentColor"/><path d="m5.8 10.3 2.7 2.7 5.7-5.9" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>Lab tested · ${u.lab}/${u.lab}</button>` : ''}
          <div class="vs-up__prices">
            <div class="vs-up__disc"><span class="vs-up__final">${money(final)}</span>${off > 0 ? `<s class="vs-up__old">${money(price)}</s>` : ''}</div>
            ${off > 0 ? `<div class="vs-up__badge">You save ${money(off)}</div>` : ''}
          </div>
          ${hasOptions ? `<span class="vs-up__optnames">${esc(u.options.join(', '))}:</span>` : ''}
          <div class="vs-up__footer">${hasOptions ? selects : ''}<button type="button" class="vs-up__add" data-vs-up-add>ADD TO CART</button></div>
        </div>
      </div>`;
    };
    const pages = [];
    for (let i = 0; i < list.length; i += 2) pages.push(list.slice(i, i + 2));
    const nav = pages.length > 1;
    return `<div class="vs-upsell"><div class="vs-carousel">
      ${nav ? `<button type="button" class="vs-carousel__nav" data-vs-nav="-1" aria-label="Previous slide" disabled>${ICON_PREV}</button>` : ''}
      <ul class="vs-carousel__list" aria-label="Product recommendations">${pages.map((p) => `<li class="vs-up">${p.map(col).join('')}</li>`).join('')}</ul>
      ${nav ? `<button type="button" class="vs-carousel__nav" data-vs-nav="1" aria-label="Next slide">${ICON_NEXT}</button>` : ''}
    </div></div>`;
  }

  function footerHTML() {
    // One set can be several store discounts with look-alike titles (non-breaking space or curly apostrophe), so titles are normalized before de-duping.
    const titles = [];
    const addTitle = (t) => {
      if (!t) return;
      t = t.replace(/\u00a0/g, ' ').replace(/\u2019/g, "'");
      if (!titles.includes(t)) titles.push(t);
    };
    cart.items.forEach((i) =>
      (i.line_level_discount_allocations || []).forEach((a) => addTitle(a.discount_application && a.discount_application.title))
    );
    (cart.cart_level_discount_applications || []).forEach((a) => addTitle(a.title));
    const disc = cart.original_total_price - cart.total_price;
    let html = '';
    if (disc > 0) {
      html += `<div class="vs-foot__disc"><div class="vs-foot__disc-title">Discounts ${titles
        .map((t) => `<span class="vs-foot__disc-badge">${ICON_TAG_OUTLINE}<span>${esc(t)}</span></span>`)
        .join('')}</div><div class="vs-foot__disc-amt">-${money(disc)}</div></div>`;
    }
    html += `<div class="vs-foot__sub">SUBTOTAL <span>${money(cart.total_price)}${disc > 0 ? `<s>${money(cart.original_total_price)}</s>` : ''}</span></div>`; /* VORSØ sleek: total, then struck total */
    return html;
  }

  function render() {
    if (!cart) return;
    const count = cart.item_count;
    root.setAttribute('aria-label', `Cart • ${count} Items`);
    const logo = $('.vs-cart__logo');
    if (logo) logo.alt = `Cart • ${count} Items`;
    if (!count) {
      contents.innerHTML = '';
      contents.hidden = true;
      footerWrap.hidden = true;
      empty.hidden = false;
      return;
    }
    empty.hidden = true;
    contents.hidden = false;
    footerWrap.hidden = false;
    const scroll = contents.scrollTop;
    contents.innerHTML = tierHTML() + `<div class="vs-items">${cart.items.map(itemHTML).join('')}</div>` + upsellHTML();
    contents.scrollTop = scroll;
    renderedSig = sig(cart);
    animateBar(lastPct, root.classList.contains('is-open') ? 0 : 120);
    footer.innerHTML = footerHTML();
    updateNav();
  }

  // What the drawer shows; when this is unchanged there is nothing to re-render.
  const sig = (c) => (c ? c.items.map((i) => `${i.key}:${i.quantity}:${i.final_line_price}`).join('|') + `#${c.total_price}#${c.original_total_price}` : '');
  let renderedSig = '';
  const EASE = 'cubic-bezier(.32,.72,0,1)';
  const still = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Free-shipping bar: transform only, so it never triggers layout while the drawer slides.
  function animateBar(from, delay = 0) {
    const fill = contents.querySelector('.vs-tier__fill');
    if (!fill) return;
    const to = Number(fill.dataset.to);
    fill.style.transform = `scaleX(${to})`;
    if (from !== to && !still.matches && fill.animate) {
      fill.animate([{ transform: `scaleX(${from})` }, { transform: `scaleX(${to})` }], { duration: 450, delay, easing: EASE, fill: 'backwards' });
    }
    lastPct = to;
  }

  // ---------- cart api ----------
  const json = (r) => r.json();
  const fetchCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(json);

  async function notifyTheme(action, lines) {
    try {
      const { CartLinesUpdateEvent } = await import('@shopify/events');
      const d = CartLinesUpdateEvent.createPromise();
      root.dispatchEvent(new CartLinesUpdateEvent({ action, context: 'cart', lines, promise: d.promise }));
      d.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, itemCount: cart.item_count, source: 'vs-cart' },
      });
    } catch (e) {
      /* no-op */
    }
  }

  // VORSØ guard: a set product itself (no sizes, no stock of its own) must never be bought as-is.
  // If one lands in the cart (old link, another channel, an app), take it out and send the shopper
  // to the set page to pick sizes. Sets add their real pieces as separate lines, so those are untouched.
  let straying = false;
  const setOf = (variantId) =>
    (getConfig().sets || []).find((s) => (s.variants || []).map(String).includes(String(variantId)));
  function dropStraySets(c) {
    if (straying || !c || !Array.isArray(c.items)) return false;
    const stray = c.items.filter((i) => setOf(i.variant_id));
    if (!stray.length) return false;
    straying = true;
    const url = setOf(stray[0].variant_id).url;
    const updates = {};
    stray.forEach((i) => (updates[i.key] = 0));
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates })
    })
      .catch(() => {})
      .finally(() => {
        window.location.href = url + (url.includes('?') ? '&' : '?') + 'pick_sizes=1';
      });
    return true;
  }

  function setCart(next, opts = {}) {
    if (dropStraySets(next)) return;
    cart = next;
    render();
    syncAddonCodes();
    if (opts.added && getConfig().openOnAdd) open();
  }

  // Discount codes the drawer manages (all made in Shopify admin → Discounts, listed in snippets/vs-cart.liquid):
  // - Add-ons: each boxer add-on has a code ($5 off once per order), applied while an add-on line from this drawer
  //   sits in the cart next to something else.
  // - Sets: each set has a code, applied only while every piece of that set (with its count) is in the cart.
  //   Founder's (all five pieces) replaces the two Everyday sets. Each code also keeps the set's minimum subtotal.
  // Codes the customer entered are kept. Only called with carts from the Ajax API (they carry discount_codes).
  let syncing = null;
  let syncAgain = false;
  function syncAddonCodes() {
    if (syncing) {
      syncAgain = true;
      return syncing;
    }
    syncing = applyCodes().finally(() => {
      syncing = null;
      if (syncAgain) {
        syncAgain = false;
        syncAddonCodes();
      }
    });
    return syncing;
  }
  async function applyCodes() {
    const cfg = getConfig();
    const ups = (cfg.upsells || []).filter((u) => u.code);
    const sets = (cfg.bundles || []).filter((b) => b.code && b.items && Object.keys(b.items).length);
    if (!cart || !Array.isArray(cart.discount_codes) || !(ups.length || sets.length)) return;
    const same = (a, b) => a.toLowerCase() === b.toLowerCase();
    const managed = (c) => ups.some((u) => same(u.code, c)) || sets.some((b) => same(b.code, c));
    const isAddon = (i) => i.properties && i.properties._upsell;
    const count = (id) => cart.items.reduce((n, i) => (String(i.product_id) === String(id) ? n + i.quantity : n), 0);
    const complete = (b) => Object.entries(b.items).every(([id, n]) => count(id) >= n);
    const want = cart.items.some((i) => !isAddon(i))
      ? ups.filter((u) => cart.items.some((i) => isAddon(i) && i.product_id === u.productId)).map((u) => u.code)
      : [];
    for (const b of sets) {
      if (!complete(b)) continue;
      want.push(b.code);
      if (b.exclusive) break;
    }
    const current = cart.discount_codes.map((d) => d.code);
    const have = current.filter(managed);
    if (want.length === have.length && want.every((c) => have.some((h) => same(h, c)))) return;
    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: current.filter((c) => !managed(c)).concat(want).join(',') }),
      });
      if (res.ok) {
        cart = await res.json();
        render();
      }
    } catch (e) {
      /* the cart still works at full price */
    }
  }

  async function removeLine(key) {
    const line = cart.items.find((i) => i.key === key);
    const row = root.querySelector(`.vs-item[data-key="${CSS.escape(key)}"]`);
    if (row) row.classList.add('is-busy');
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 }),
      });
      if (!res.ok) throw new Error();
      setCart(await res.json());
      notifyTheme('remove', line ? [{ merchandiseId: String(line.variant_id), quantity: 0 }] : []);
    } catch (e) {
      if (row) row.classList.remove('is-busy');
      setCart(await fetchCart());
    }
  }

  // VORSØ quantity stepper: the number updates at once; the cart is told 350ms after the last click.
  const qtyTimers = {};
  function bumpQty(key, delta) {
    const row = root.querySelector(`.vs-item[data-key="${CSS.escape(key)}"]`);
    const out = row && row.querySelector('[data-vs-qty-val]');
    if (!out) return;
    const next = Math.max(1, Number(out.textContent) + delta);
    out.textContent = next;
    const minus = row.querySelector('[data-vs-qty="-1"]');
    if (minus) minus.disabled = next <= 1;
    clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(() => setQty(key, next), 350);
  }
  async function setQty(key, qty) {
    delete qtyTimers[key];
    const line = cart.items.find((i) => i.key === key);
    if (!line || line.quantity === qty) return;
    const row = root.querySelector(`.vs-item[data-key="${CSS.escape(key)}"]`);
    if (row) row.classList.add('is-busy');
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      });
      if (!res.ok) {
        let msg = '';
        try { msg = (await res.json()).description || ''; } catch (e) {}
        setCart(await fetchCart());
        const again = root.querySelector(`.vs-item[data-key="${CSS.escape(key)}"] .vs-qty`);
        if (again && msg) {
          const p = document.createElement('p');
          p.className = 'vs-qty__err';
          p.textContent = msg;
          again.after(p);
          setTimeout(() => p.remove(), 4000);
        }
        return;
      }
      setCart(await res.json());
      notifyTheme('update', [{ merchandiseId: String(line.variant_id), quantity: qty }]);
    } catch (e) {
      if (row) row.classList.remove('is-busy');
      setCart(await fetchCart());
    }
  }

  async function addUpsell(card, button) {
    const u = getConfig().upsells.find((x) => String(x.productId) === card.dataset.vsUp);
    if (!u) return;
    const picked = [...card.querySelectorAll('[data-vs-up-option]')].map((g) => (g.querySelector('input:checked') || {}).value);
    const v = picked.length ? u.variants.find((x) => picked.every((val, i) => x.options[i] === val)) : u.variants[0];
    if (!v || !v.available) {
      button.textContent = 'Out of stock';
      return;
    }
    button.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: { _upsell: '1' } }] }),
      });
      if (!res.ok) throw new Error();
      setCart(await fetchCart());
      notifyTheme('add', [{ merchandiseId: String(v.id), quantity: 1 }]);
    } catch (e) {
      button.disabled = false;
    }
  }

  function updateNav() {
    const listEl = root.querySelector('.vs-carousel__list');
    if (!listEl) return;
    const prev = root.querySelector('[data-vs-nav="-1"]');
    const next = root.querySelector('[data-vs-nav="1"]');
    const sync = () => {
      if (prev) prev.disabled = listEl.scrollLeft <= 2;
      if (next) next.disabled = listEl.scrollLeft + listEl.clientWidth >= listEl.scrollWidth - 2;
    };
    listEl.onscroll = sync;
    sync();
  }

  // ---------- open / close ----------
  function open() {
    if (root.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    if (!cart) cart = getConfig().cart;
    lastPct = 0; // the bar refills from empty on every open, like Kaching
    if (sig(cart) !== renderedSig) render();
    else animateBar(0, 120);
    root.inert = false;
    root.classList.add('is-open');
    document.documentElement.setAttribute('scroll-lock', '');
    document.querySelectorAll('[data-vs-cart-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
    requestAnimationFrame(() => $('.vs-cart__close').focus({ preventScroll: true }));
    fetchCart().then((c) => {
      // Never swap the drawer's contents mid-slide: re-render (if anything changed) once it has landed.
      const changed = sig(c) !== sig(cart);
      cart = c;
      if (!changed) return syncAddonCodes();
      setTimeout(() => cart === c && setCart(c), 320);
    });
  }

  function close() {
    if (!root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    root.inert = true;
    document.documentElement.removeAttribute('scroll-lock');
    document.querySelectorAll('[data-vs-cart-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  const toggle = () => (root.classList.contains('is-open') ? close() : open());

  // ---------- events ----------
  root.addEventListener('click', (e) => {
    const t = e.target;
    if (t.closest('[data-vs-close]')) return close();
    const rm = t.closest('[data-vs-remove]');
    if (rm) return removeLine(rm.dataset.vsRemove);
    const qb = t.closest('[data-vs-qty]');
    if (qb) return bumpQty(qb.closest('.vs-item').dataset.key, Number(qb.dataset.vsQty));
    const tg = t.closest('[data-vs-toggle]');
    if (tg) {
      const k = tg.dataset.vsToggle;
      collapsed.has(k) ? collapsed.delete(k) : collapsed.add(k);
      return render();
    }
    const add = t.closest('[data-vs-up-add]');
    if (add) return addUpsell(add.closest('[data-vs-up]'), add);
    const nav = t.closest('[data-vs-nav]');
    if (nav) {
      const listEl = root.querySelector('.vs-carousel__list');
      return listEl && listEl.scrollBy({ left: Number(nav.dataset.vsNav) * listEl.clientWidth, behavior: 'smooth' });
    }
    if (t.closest('[data-vs-checkout]')) {
      t.closest('[data-vs-checkout]').setAttribute('aria-busy', 'true');
      (async () => {
        while (syncing) await syncing.catch(() => {});
        window.location.href = '/checkout';
      })();
    }
  });

  root.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });

  // Header cart button + any /cart link opens the drawer (capture runs before the theme's handlers).
  window.addEventListener(
    'click',
    (e) => {
      const trigger = e.target.closest('[data-vs-cart-toggle], a[href="/cart"], a[href$="/cart"]');
      if (!trigger || root.contains(trigger) || (document.querySelector('main[data-template]') || {dataset:{}}).dataset.template === 'cart') return;
      if (trigger.tagName === 'A' && (e.metaKey || e.ctrlKey || e.shiftKey)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      toggle();
    },
    true
  );

  // A set is sold as its components (each needs a size), so a direct add of the set product itself
  // (collection quick add, featured product blocks) opens its product page instead.
  const setUrlForVariant = (id) => {
    const s = (getConfig().sets || []).find((x) => (x.variants || []).map(String).includes(String(id)));
    return s && s.url;
  };
  window.addEventListener(
    'submit',
    (e) => {
      const form = e.target;
      const idInput = form && form.querySelector && form.querySelector('input[name="id"]');
      const url = idInput && setUrlForVariant(idInput.value);
      if (!url) return;
      const section = form.closest('.shopify-section');
      if (section && section.querySelector('vs-bundle[data-mode="set"]')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = url;
    },
    true
  );

  // Theme add-to-cart (multipacks, singles, quick add) -> keep the drawer in sync.
  document.addEventListener('shopify:cart:lines-update', (e) => {
    if (!e.promise || typeof e.promise.then !== 'function') return;
    e.promise
      .then((data) => {
        const src = data && data.detail && data.detail.source;
        if (src === 'vs-cart' || src === 'vs-bundle') return;
        return fetchCart().then((c) => setCart(c, { added: e.action === 'add' }));
      })
      .catch(() => {});
  });

  // Anything that calls Shopify.actions.openCart opens this drawer.
  const hookActions = () => {
    const a = window.Shopify && Shopify.actions;
    if (a && a.openCart && a.openCart.configure) a.openCart.configure({ handler: async () => open() });
  };
  if (document.readyState === 'complete') hookActions();
  else window.addEventListener('load', hookActions, { once: true });

  window.vsCart = { open, close, toggle, setCart, refresh: () => fetchCart().then((c) => setCart(c)) };

  // Build the drawer once the page is idle, so the first open is only a slide (rows and photos already there).
  const warm = () => {
    const c = cart || getConfig().cart;
    if (renderedSig || !c || !c.item_count) return;
    cart = c;
    render();
  };
  window.requestIdleCallback ? requestIdleCallback(warm, { timeout: 3000 }) : setTimeout(warm, 1500);

  // Keep the codes right on every page load too (e.g. a set piece removed on the cart page or in another tab).
  const syncOnLoad = () => {
    const c0 = getConfig().cart;
    if (!c0 || !c0.item_count) return;
    fetchCart()
      .then((c) => {
        if (dropStraySets(c)) return;
        if (!cart || sig(c) !== sig(cart)) setCart(c);
        else {
          cart = c;
          syncAddonCodes();
        }
      })
      .catch(() => {});
  };
  window.requestIdleCallback ? requestIdleCallback(syncOnLoad, { timeout: 4000 }) : setTimeout(syncOnLoad, 2000);

  // Cart page quantity changes and removals.
  if (/\/cart\/?$/.test(location.pathname)) {
    document.addEventListener('cart:update', (e) => {
      const src = e.detail && e.detail.data && e.detail.data.source;
      if (src === 'vs-cart' || src === 'vs-bundle') return;
      fetchCart()
        .then((c) => setCart(c))
        .catch(() => {});
    });
  }
}

/* ---------- VORSØ lab badges (snippets/vs-lab.liquid). Lives here so it ships in a file every page already loads. ---------- */
  (function () {
    if (window.__vsLab) return;
    window.__vsLab = 1;
    var root = document.documentElement;
    var loading = {};

    function onClose() {
      var cart = document.getElementById('vs-cart');
      if (!document.querySelector('dialog[open]') && !(cart && cart.classList.contains('is-open'))) root.removeAttribute('scroll-lock');
    }
    function have(id) {
      return document.getElementById('vs-labd-' + id) || document.querySelector('template[data-vs-labd="' + id + '"]');
    }
    // Cards only carry the badge. The results sheet is fetched once, on first hover/touch/focus, from /products/<handle>?view=vs-lab.
    function load(id, url) {
      if (have(id) || !url) return Promise.resolve();
      if (!loading[id]) {
        loading[id] = fetch(url, { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) {
            if (have(id)) return;
            var t = new DOMParser().parseFromString(html, 'text/html').querySelector('template[data-vs-labd="' + id + '"]');
            if (t) document.body.appendChild(document.importNode(t, true));
          })
          .catch(function () { delete loading[id]; });
      }
      return loading[id];
    }
    function getDialog(id) {
      var d = document.getElementById('vs-labd-' + id);
      if (d) return d;
      var t = document.querySelector('template[data-vs-labd="' + id + '"]');
      if (!t) return null;
      document.body.appendChild(t.content.cloneNode(true));
      d = document.getElementById('vs-labd-' + id);
      if (d) d.addEventListener('close', onClose);
      return d;
    }
    function open(b) {
      var id = b.getAttribute('data-vs-lab');
      load(id, b.getAttribute('data-vs-lab-url')).then(function () {
        var d = getDialog(id);
        if (!d || !d.showModal || d.open) return;
        d.showModal();
        root.setAttribute('scroll-lock', '');
        fitThumb(d);
      });
    }
    // Product photo in the sheet spans exactly from the product name to the date line (4:5).
    function fitThumb(d) {
      var img = d.querySelector('.vs-labd__prod > img'), txt = img && img.nextElementSibling;
      if (!txt) return;
      for (var k = 0; k < 2; k++) {
        var h = txt.offsetHeight;
        img.style.height = h + 'px';
        img.style.width = Math.round(h * 0.8) + 'px';
      }
    }
    window.addEventListener('resize', function () {
      var d = document.querySelector('dialog.vs-labd[open]');
      if (d) fitThumb(d);
    });
    function warm(e) {
      var b = e.target && e.target.closest && e.target.closest('[data-vs-lab]');
      if (b) load(b.getAttribute('data-vs-lab'), b.getAttribute('data-vs-lab-url'));
    }
    document.addEventListener('pointerover', warm, { passive: true });
    document.addEventListener('touchstart', warm, { passive: true });
    document.addEventListener('focusin', warm);

    // Capture phase: a tap on a badge never reaches the product card's link, view transition or the cart drawer.
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var b = t.closest('[data-vs-lab]');
      if (b) {
        e.preventDefault();
        e.stopPropagation();
        open(b);
        return;
      }
      var d = t.closest('dialog.vs-labd');
      if (d && (t === d || t.closest('[data-vs-labd-close]'))) d.close();
    }, true);

    function fromHash() {
      if (!/^#lab-?(results|tested)$/.test(location.hash)) return;
      var b = document.querySelector('.vs-lab[data-vs-lab]') || document.querySelector('[data-vs-lab]');
      if (b) open(b);
    }
    function place() {
      var list = document.querySelectorAll('media-gallery > .vs-lab-stk');
      for (var i = 0; i < list.length; i++) {
        var s = list[i], g = s.parentElement, gr = g.getBoundingClientRect();
        if (!gr.width) continue;
        var imgs = g.querySelectorAll('img'), img = null;
        for (var k = 0; k < imgs.length; k++) {
          var q = imgs[k].getBoundingClientRect();
          if (q.width > 0 && q.height > 0 && Math.abs(q.left - gr.left) < 2 && q.top >= gr.top - 2 && q.top < gr.bottom) { img = imgs[k]; break; }
        }
        if (!img) continue;
        var r = img.getBoundingClientRect(), x = r.left - gr.left, y = r.top - gr.top, w = r.width, h = r.height;
        if (img.naturalWidth && getComputedStyle(img).objectFit === 'contain') {
          var ar = img.naturalWidth / img.naturalHeight;
          if (w / h > ar) x += (w - h * ar) / 2; else y += (h - w / ar) / 2;
        }
        s.style.setProperty('--vs-stk-x', Math.round(x) + 'px');
        s.style.setProperty('--vs-stk-y', Math.round(y) + 'px');
      }
    }
    var placing = 0;
    function schedule() { if (!placing) placing = requestAnimationFrame(function () { placing = 0; place(); }); }
    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
    document.addEventListener('load', function (e) { if (e.target.tagName === 'IMG' && e.target.closest && e.target.closest('media-gallery')) schedule(); }, true);
    function init() { fromHash(); schedule(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

